export const recordsPerPage = {
  size: [10, 20, 50],
  defaultSize: 10,
};

export const EXPANDED = "w-[248px]";
export const COLLAPSED = "w-[54px]";

export const drinkTypes = [
  { value: "spirit", label: "Base" },
  { value: "mixer", label: "Mixer" },
  { value: "extra", label: "Extra" },
];

export const defaultUiState = {
  isSidebarOpen: true,
  sidebarWidth: EXPANDED,
};

export const productCategories = ["food", "drink"] as const;
export const customDrinkTypes = ["spirit", "mixer", "extra"] as const;
